import React, { useEffect, useState } from 'react'
import api from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, DialogActions, Typography } from '@mui/material';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Loading from '../../load/loading';
import Date from '../../utils/date';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useSelector } from "react-redux";

interface Solicitacao {
  numeroDeclaracao: string;
  numeroPorte: string;
  dataAprovacao: string;
  numeroCertificado: string;
  dataEmissao: string;
  importador: {
    empresa: {
      nome: string;
    }
  }
}

const ConsultaCertificadoEmitido = () => {
  const user = useSelector((state: { account: { user: any } }) => state.account.user);
  const { tipo, id } = useParams();
  const [solicitacao, setSolicitacao] = useState<Solicitacao>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    if (tipo === 'certificado') {
      api.get(`/certificado/${id}`)
        .then((response) => {
          setSolicitacao(response.data.certificadoImportacao);
        })
        .catch((err) => '')
        .finally(() => setLoading(false));

    } else {
      api.get(`/declaracao-desalfandegamento/${id}`)
        .then((response) => {
          setSolicitacao(response.data.declaracaoDesalfandegamento);
        })
        .catch((err) => '')
        .finally(() => setLoading(false));
    }

  }, [id, tipo])

  if (loading) {
    <Loading text='A VERIFICAR DOCUMENTO...' focus={''} />
  }

  const numeroCompleto = solicitacao?.numeroDeclaracao || "";
  const [numero, anoDeclarao] = numeroCompleto.split("/");

  const numeroCompletoCertificado = solicitacao?.numeroCertificado || "";
  const [numeroCertificado, anoCertificado] = numeroCompletoCertificado.split("/");

  return (
    <div style={{ minHeight: '75vh' }}>

      {tipo === 'certificado' ?
        <>


          {solicitacao ? <Card style={{ padding: 20, maxWidth: 500, margin: 'auto' }}>
            <Typography align='center'>
              <CheckCircleOutlineIcon
                color="success"
                className="tw-text-[80px] tw-mb-2" />
              <br />
              <b>Autenticidade de documentação</b>
              <br />
              <br />
            </Typography>

            <Typography variant="body2">Nº do Certificado: <b>{numeroCertificado}/ARMED/MINSA/{anoCertificado}</b></Typography>
            <Typography variant="body2">Tipo de documento: <b>Certificado</b></Typography>
            <br />

            <Typography variant="body2">Este documento foi emitido pela - ARMED, em Luanda aos,   <b><Date date={solicitacao?.dataEmissao} /></b></Typography>
            <br />
            {user &&
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={() => navigate(`/admin/dmts/gest/solicitacao-de-importacao/${id}`)}
                  sx={{
                    backgroundColor: '#85287E',
                    color: '#FFFFFF',
                    borderColor: '#85287E',
                    '&:hover': {
                      backgroundColor: '#6A2065',
                    },
                    textTransform: 'none',
                    padding: '8px 16px',
                    fontWeight: 'bold',
                  }}
                >
                  Ver Processo
                </Button>
              </DialogActions>
            }
          </Card> :
            <div style={{ padding: 20 }}>
              <Typography align='center'>
                <ErrorOutlineIcon sx={{fontSize: 50}} />
                <br />
                <b>Autenticidade de documentação</b>
                <br />
                <br />
              </Typography>
              <Typography style={{ lineHeight: 1 }} align="center" variant="subtitle1">
                Certificado não reconhecida pela ARMED
              </Typography>
            </div>}
        </>
        : <>

          {solicitacao ? <Card style={{ padding: 20, maxWidth: 500, margin: 'auto' }}>
            <Typography align='center'>
              <CheckCircleOutlineIcon
                color="success"
                className="tw-text-[80px] tw-mb-2" />
              <br />
              <b>Autenticidade de documentação</b>
              <br />
              <br />
            </Typography>
            <Typography variant="body2">Declaração de Desalfandegamento Nº: <b>{numero}/ARMED/MINSA/{anoDeclarao}</b></Typography>
            <Typography variant="body2">Tipo de documento: <b>Declaração de Desalfandegamento</b></Typography>
            <Typography variant="body2">Importador: <b>{solicitacao?.importador.empresa.nome}</b></Typography>
            <Typography variant="body2">Nº de Porte: <b>{solicitacao?.numeroPorte}</b></Typography>
            <br />


            <Typography variant="body2">Este documento foi emitido pelo Chefe de Departamento de LIF - ARMED, em Luanda aos,   <b><Date date={solicitacao?.dataAprovacao} /></b></Typography>
            {user &&
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={() => navigate(`/admin/dmts/gest/solicitacao-de-importacao/${id}`)}
                  sx={{
                    backgroundColor: '#85287E',
                    color: '#FFFFFF',
                    borderColor: '#85287E',
                    '&:hover': {
                      backgroundColor: '#6A2065',
                    },
                    textTransform: 'none',
                    padding: '8px 16px',
                    fontWeight: 'bold',
                  }}
                >
                  Ver Processo
                </Button>
              </DialogActions>
            }
          </Card> :
            <div style={{ padding: 20 }}>
              <Typography align='center'>
                <ErrorOutlineIcon sx={{fontSize: 50}} />
                <br />
                <b>Autenticidade de documentação</b>
                <br />
                <br />
              </Typography>

              <Typography style={{ lineHeight: 1 }} align="center" variant="subtitle1">
                Declaração não reconhecida pela ARMED
              </Typography>
            </div>}
        </>
      }

    </div>
  )
}

export default ConsultaCertificadoEmitido
